export default __webpack_public_path__ + "fc4d334128e0bbfe8b8f2143ed97e4f1.svg";